import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
//
//MUI Components
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid, GridToolbar } from "@material-ui/data-grid";
import Typography from "@material-ui/core/Typography";
import { Button, useTheme } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";

const useStyles = makeStyles((theme) => ({
	datagrid: {
		backgroundColor: "white",
		// Remove outlines because they're gross
		"&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
			outline: "none",
		},
	},
	url: {
		color: theme.palette.primary.main,
	},
}));

export default function ExternalSites() {
	const theme = useTheme();
	const [rows, setRows] = useState([]);
	const [selectionModel, setSelectionModel] = useState([]);
	const [sortModel, setSortModel] = useState([{ field: "name", sort: "asc" }]);

	const classes = useStyles();

	useEffect(() => {
		const fetchRows = async () => {
			const res = await fetch(`${process.env.REACT_APP_API_URL}/externalsites`);
			const data = await res.json();
			return data;
		};

		const getRows = async () => {
			let rowsFromServer = await fetchRows();
			setRows(rowsFromServer.data);
		};
		getRows();
	}, []);

	const deleteFromAPI = async (id) => {
		try {
			await fetch(`${process.env.REACT_APP_API_URL}/externalsites/${id}`, {
				method: "DELETE",
				credentials: "include",
			});
		} catch (e) {
			console.log(e);
		}
	};

	const onClickDeleteAll = async () => {
		selectionModel.forEach((id) => {
			deleteFromAPI(id);
		});

		//Remove selectionModeled items from the rows state
		let newRows = [...rows];
		for (let i = 0; i < selectionModel.length; i++) {
			newRows = newRows.filter((row) => row._id !== selectionModel[i]);
		}
		await setRows(newRows);

		//Clear selection
		setSelectionModel([]);
	};

	const columns = useMemo(
		() => [
			{ field: "_id", headerName: "ID", hide: true, width: 225 },
			{
				field: "name",
				headerName: "Name",
				renderCell: (params) => {
					return (
						<React.Fragment>
							<IconButton
								component={Link}
								to={`/${process.env.REACT_APP_ADMIN_URL}/externalsites/${params.row._id}`}
								style={{ marginRight: ".5rem" }}
								aria-label="edit"
							>
								<EditIcon />
							</IconButton>
							{params.value}
						</React.Fragment>
					);
				},
				width: 300,
			},
			{
				field: "url",
				headerName: "URL",
				width: 225,
				renderCell: (params) => {
					return (
						<Typography component="p" variant="p">
							<a
								className={classes.url}
								href={`${params.row.url}`}
								target="_blank"
								rel="noreferrer"
							>
								{params.row.url}
							</a>
						</Typography>
					);
				},
			},
		],
		[classes.url]
	);

	return (
		<>
			<div style={{ display: "flex", alignItems: "center" }}>
				<Typography component="h1" variant="h4">
					External Sites
				</Typography>
				<Button
					startIcon={<AddIcon />}
					style={{ marginLeft: "1rem" }}
					color="primary"
					variant="contained"
					component={Link}
					to={`/${process.env.REACT_APP_ADMIN_URL}/externalsites/add`}
				>
					Add New
				</Button>
				{selectionModel.length > 0 && (
					<Button
						startIcon={<DeleteIcon />}
						style={{ marginLeft: "1rem" }}
						color="secondary"
						variant="contained"
						onClick={onClickDeleteAll}
					>
						Delete
					</Button>
				)}
			</div>
			<Typography style={{ margin: 0, paddingBottom: "1rem" }}>
				These are shown on the{" "}
				<Link to="/" style={{ color: theme.palette.primary.main }}>
					Site Select page
				</Link>
			</Typography>
			<DataGrid
				className={classes.datagrid}
				components={{
					Toolbar: GridToolbar,
				}}
				getRowId={(row) => row._id}
				autoHeight
				rows={rows}
				columns={columns}
				checkboxSelection
				selectionModel={selectionModel}
				sortModel={sortModel}
				onSortModelChange={(model) => setSortModel(model)}
				onSelectionModelChange={(newSelection) => {
					setSelectionModel(newSelection);
				}}
			/>
		</>
	);
}
